export default [
	{ label: "Namn",                field: "namn"               },
	{ label: "Stomnät",             field: "natnamn"            },
	{ label: "Typ",                 field: "typ"                },
	{ label: "Markering",           field: "markering"          },
	{ label: "Kommun",              field: "kommun"             },
	{ label: "Kommunkod",           field: "kommunkod"          },
	{ label: "Län",                 field: "lan"                },
	{ label: "Länskod",             field: "lanskod"            },
	{ label: "Markerad",            field: "markerad"           },
	{ label: "Återfunnen",          field: "aterfunnen"         },
	{ label: "Ej återfunnen",       field: "ej_aterfunnen"      },
	{ label: "Förstörd",            field: "forstord"           },
	{ label: "Lägesosäkerhet plan", field: "lagesosakerhet_plan"},
	{ label: "Lägesosäkerhet höjd", field: "lagesosakerhet_hojd"},
	{ label: "RHB 70",              field: "rhb70"              },
	{ label: "RH 70",               field: "rh70"               },
	{ label: "RH 00",               field: "rh00"               }
]



// WEBPACK FOOTER //
// ./src/constants/fields.js